<template>
  <el-row class="nationwide-universal-ticket">
    <el-col :span="24">
      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('movie.commonTicket') }}</div>
      <!-- ムビチケ -->
      <p>{{ $locale("movie.ticket.common") }}</p>
      <el-form-item :label="$locale('movie.nationwideUniversalTicket')" prop="nationalTicket.national" class="w120">
          <BoolSelect :value.sync="formData.national" @change="evt => changeAction(evt, 'national')" :disabled="isLoading"></BoolSelect>
        </el-form-item>
      <collapse-title :display.sync="isShowDetail" v-show="formData.national">
        {{ $locale("movie.ticketMaster.listOfTickets") }}
      </collapse-title>

      <section class="movi-ticket" v-show="isShowDetail">
        <div class="loading-overlay" v-if="isLoading"><i class="el-icon-loading"></i> {{ $locale('global.loading') }}...</div>
        <!-- <div class="fixed-height-container" @scroll="_debounce" ref="mvtkContainer">
          <template v-if="formData.national">
            <CommonTicket
              v-if="hasMoviTicket"
              :formData="formData"
              fieldName="nationalTicket"
              :distributorOptions="distributorOptions"
              :versionList="versionList"
              :authority="authority"
            ></CommonTicket>
            <template v-else>
              <span v-if="isLoading"><i class="el-icon-loading"></i></span>
              <span v-if="!isLoading && formData.nationalTicket.length === 0" class="no-data-span">{{ $locale("global.noData") }}</span>
            </template>
          </template>
        </div> -->
        <CommonTicketTable
          v-if="hasMoviTicket"
          :authority="authority"
          :movieTicketList="formData.nationalTicket"
        />
      </section>

      <section v-if="adminType === adminTypeList.CINEMA">
        <!-- その他全国共通券 -->
        <p>{{ $locale("movie.ticket.other") }}</p>

        <el-form-item :label="$locale('movie.nationwideUniversalTicket')" prop="otherNational" class="w120">
          <BoolSelect :value.sync="formData.otherNational" @change="evt => changeAction(evt, 'otherNational')"></BoolSelect>
        </el-form-item>

        <template v-if="formData.otherNational">
          <CommonTicket
            :formData="formData"
            fieldName="otherNationalTicket"
            :distributorOptions="distributorOptions"
            :versionList="versionList"
            :authority="authorityOther"
            @delItem="delOtherItemAction"
          ></CommonTicket>
        </template>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from "vuex";
import { localStorage } from "@/utils/localStorage";
import tranfResData from "@/utils/tranfResData";
import {
  movieDetailAuthority,
  movieDetailAuthorityOther,
  ticketUtilizeObj,
} from "@/assets/js/movieStatic";
import { adminTypeList } from "@/utils/common";
import CommonTicket from "./CommonTicket";
import CommonTicketTable from "./CommonTicketTable";
import BoolSelect from "./BoolSelect";
import CollapseTitle from "./CollapseTitle";

export default {
  name: "nationwide-universal-ticket",
  componentName: "NationTicket",
  components: {
    CommonTicket,
    CommonTicketTable,
    BoolSelect,
    CollapseTitle,
  },
  props: {
    formData: {
      required: true,
      type: Object,
    },
    distributorOptions: {
      required: true,
      type: Array,
    },
    versionList: {
      required: true,
      type: Array,
    },
    isLoading: {
      type: Boolean,
    },
    pageCounts: {
      required: true,
      type: Number,
    }
  },
  data() {
    return {
      isShowDetail: false,
      adminTypeList,
      currentPage: 1,
    };
  },
  computed: {
    ...mapState("app", {
      _adminType: state => state.adminType,
    }),
    adminType() {
      return this._adminType ? this._adminType : localStorage.get("adminType");
    },
    authority() {
      return movieDetailAuthority[this.adminType];
    },
    hasMoviTicket() {
      return this.formData.nationalTicket.length > 0;
    },
    authorityOther() {
      return movieDetailAuthorityOther[this.adminType];
    },
  },
  created() {
    this._debounce = this.$_.debounce(this.scrollAction, 600, false);
  },
  methods: {
    changeAction(fieldVal, fieldName) {
      switch(fieldName) {
      case "national":
        if (fieldVal) { // option = true
          this.$emit("getMoviTicketList");
        } else { // option = false
          // this.$refs.mvtkContainer.scrollTo(0, 0);
          this.formData.nationalTicket = [];
          this.currentPage = 1;
          this.isShowDetail = false;
        }
        break;

      case "otherNational":
        if (fieldVal) { // option = true
          this.formData.otherNationalTicket = this.formData.otherNationalTicket.length > 0 ?
            this.formData.otherNationalTicket : [ tranfResData(ticketUtilizeObj) ];
        }
        // else { // option = false
        //   // this.formData.otherNationalTicket = [];
        // }
        break;

      default:
        break;
      }
    },
    delOtherItemAction(idx) {
      this.formData.otherNationalTicket.splice(idx, 1);
    },
    scrollAction(evt) {
      const { scrollTop, scrollHeight, offsetHeight, offsetTop } = evt.target;
      const _offset = offsetHeight + offsetTop + 100;

      if (
        !this.isLoading
          && this.formData.nationalTicket.length < this.pageCounts
          && scrollTop + _offset > scrollHeight
          && scrollTop > 0
      ) {
        this.$emit("getMoviTicketList", this.currentPage);
        this.currentPage += 1;
      }
    },
  },
};
</script>

<style scoped lang="less">
.nationwide-universal-ticket {
  .no-data-span {
    font-size: 1rem;
    color: @error-red;
  }

  .movi-ticket {
    position: relative;
  }

  .fixed-height-container {
    position: relative;
    z-index: 1;
    height: 100%;
    margin: 20px 0;
    overflow: auto;
  }

  .loading-overlay {
    position: absolute;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30px;
    text-align: center;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.3);
  }
}
</style>
